var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLabCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 66,
    height: 66,
    rx: 33,
    fill: "#E1EB80"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.25 49.5H22C21.0276 49.5 20.0949 49.1137 19.4073 48.4261C18.7197 47.7384 18.3334 46.8058 18.3334 45.8333V23.8333C18.3334 22.8609 18.7197 21.9282 19.4073 21.2406C20.0949 20.553 21.0276 20.1667 22 20.1667H44C44.9725 20.1667 45.9051 20.553 46.5928 21.2406C47.2804 21.9282 47.6667 22.8609 47.6667 23.8333V29.3333M40.3334 16.5V23.8333M25.6667 16.5V23.8333M18.3334 31.1667H36.6667M44 41.25V44L44.9167 44.9167M36.6667 44C36.6667 45.9449 37.4393 47.8102 38.8146 49.1854C40.1899 50.5607 42.0551 51.3333 44 51.3333C45.945 51.3333 47.8102 50.5607 49.1855 49.1854C50.5608 47.8102 51.3334 45.9449 51.3334 44C51.3334 42.0551 50.5608 40.1898 49.1855 38.8145C47.8102 37.4393 45.945 36.6667 44 36.6667C42.0551 36.6667 40.1899 37.4393 38.8146 38.8145C37.4393 40.1898 36.6667 42.0551 36.6667 44Z",
    stroke: "#161E35",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabCalendar);
export default __webpack_public_path__ + "static/media/lab-calendar.0adf5f4792e34ad50ebc3b3755f86f21.svg";
export { ForwardRef as ReactComponent };